import { utils, Contract, ContractFactory } from 'ethers';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _abi$h = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenUSDC",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenBUMP",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountUSDC",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountBUMP",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amountUSDC",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountBUMP",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "claimArgs",
                type: "bytes[]",
            },
        ],
        name: "claimBulk",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32",
            },
        ],
        name: "setMerkleRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenBUMP",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenUSDC",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode$c = "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";
var isSuperArgs$c = function (xs) { return xs.length > 1; };
var Airdrop__factory = /** @class */ (function (_super) {
    __extends(Airdrop__factory, _super);
    function Airdrop__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$c(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$h, _bytecode$c, args[0]) || this;
        }
        return _this;
    }
    Airdrop__factory.prototype.deploy = function (_tokenUSDC, _tokenBUMP, _merkleRoot, overrides) {
        return _super.prototype.deploy.call(this, _tokenUSDC, _tokenBUMP, _merkleRoot, overrides || {});
    };
    Airdrop__factory.prototype.getDeployTransaction = function (_tokenUSDC, _tokenBUMP, _merkleRoot, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _tokenUSDC, _tokenBUMP, _merkleRoot, overrides || {});
    };
    Airdrop__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Airdrop__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Airdrop__factory.createInterface = function () {
        return new utils.Interface(_abi$h);
    };
    Airdrop__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$h, signerOrProvider);
    };
    Airdrop__factory.bytecode = _bytecode$c;
    Airdrop__factory.abi = _abi$h;
    return Airdrop__factory;
}(ContractFactory));

var _abi$g = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "addAddressInWhiteList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "c__0x00e084d0",
                type: "bytes32",
            },
        ],
        name: "c_0x00e084d0",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "c__0x275f831b",
                type: "bytes32",
            },
        ],
        name: "c_0x275f831b",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "c__0xadae1cbc",
                type: "bytes32",
            },
        ],
        name: "c_0xadae1cbc",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "_lockTimeStamp",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_whiteListAddresses",
                type: "address[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "removeAddressFromWhiteList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_unlockTimestamp",
                type: "uint256",
            },
        ],
        name: "updateUnlockTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode$b = "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";
var isSuperArgs$b = function (xs) { return xs.length > 1; };
var BUSDC__factory = /** @class */ (function (_super) {
    __extends(BUSDC__factory, _super);
    function BUSDC__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$b(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$g, _bytecode$b, args[0]) || this;
        }
        return _this;
    }
    BUSDC__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BUSDC__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BUSDC__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BUSDC__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BUSDC__factory.createInterface = function () {
        return new utils.Interface(_abi$g);
    };
    BUSDC__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$g, signerOrProvider);
    };
    BUSDC__factory.bytecode = _bytecode$b;
    BUSDC__factory.abi = _abi$g;
    return BUSDC__factory;
}(ContractFactory));

var _abi$f = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressAddedToWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "removedWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressRemovedFromWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "burnedYearnTokens",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountWithdrawn",
                type: "uint256",
            },
        ],
        name: "AmountWithdrawnFromYearn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ApprovedAmountToYearnVault",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "BumpPurchased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "interestRate",
                type: "uint256",
            },
        ],
        name: "DepositMade",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "DepositedAmountToYearnVault",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "rewardee",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "RewardIssued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBumpPurchaseAllocation",
                type: "uint256",
            },
        ],
        name: "UpdatedBumpPurchaseAllocation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBumpRewardAllocation",
                type: "uint256",
            },
        ],
        name: "UpdatedBumpRewardAllocation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMaxBumpPercent",
                type: "uint256",
            },
        ],
        name: "UpdatedMaxBumpPercent",
        type: "event",
    },
    {
        inputs: [],
        name: "BUMP_INITAL_PRICE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BUMP_REWARDS_BONUS_DRAG",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BUMP_REWARDS_BONUS_DRAG_DIVIDER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BUMP_REWARDS_FORMULA_CONSTANT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SWAP_RATE_CONSTANT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "addAddressToWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "approveUSDCToYearnVault",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "bumpPurchaseAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bumpRewardAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bumpTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "busdcTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTVL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountForBumpPurchase",
                type: "uint256",
            },
            {
                internalType: "enum BumpMarket.StableCoins",
                name: "_coin",
                type: "uint8",
            },
        ],
        name: "depositAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "depositDetails",
        outputs: [
            {
                internalType: "uint256",
                name: "interest",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "depositUSDCInYearnVault",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalDeposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountForPurchase",
                type: "uint256",
            },
        ],
        name: "estimateBumpRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_deposit",
                type: "uint256",
            },
        ],
        name: "estimateSwapRateBumpUsdc",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum BumpMarket.StableCoins",
                name: "_coin",
                type: "uint8",
            },
        ],
        name: "getCurrentPrice",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSwapRateBumpUsdc",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getyUSDCIssuedToReserve",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_usdcAddresses",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_whitelistAddresses",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "_bumpTokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_busdcTokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_maxBumpPercent",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_bumpRewardAllocation",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_bumpPurchaseAllocation",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "maxBumpPercent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseProtocol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "removeAddressFromWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "swap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpauseProtocol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bumpPurchaseAllocation",
                type: "uint256",
            },
        ],
        name: "updateBumpPurchaseAllocation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bumpRewardAllocation",
                type: "uint256",
            },
        ],
        name: "updateBumpRewardAllocation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxBumpPercent",
                type: "uint256",
            },
        ],
        name: "updateMaxBumpPercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "usdcForBumpPurchase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "usdcVault",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawUSDCFromBumperMarket",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdrawUSDCFromYearnVault",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode$a = "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";
var isSuperArgs$a = function (xs) { return xs.length > 1; };
var BumpMarket__factory = /** @class */ (function (_super) {
    __extends(BumpMarket__factory, _super);
    function BumpMarket__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$a(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$f, _bytecode$a, args[0]) || this;
        }
        return _this;
    }
    BumpMarket__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BumpMarket__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BumpMarket__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BumpMarket__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BumpMarket__factory.createInterface = function () {
        return new utils.Interface(_abi$f);
    };
    BumpMarket__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$f, signerOrProvider);
    };
    BumpMarket__factory.bytecode = _bytecode$a;
    BumpMarket__factory.abi = _abi$f;
    return BumpMarket__factory;
}(ContractFactory));

var _abi$e = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressAddedToWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "removedWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressRemovedFromWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "burnedYearnTokens",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountWithdrawn",
                type: "uint256",
            },
        ],
        name: "AmountWithdrawnFromYearn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ApprovedAmountToYearnVault",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "BumpPurchased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "interestRate",
                type: "uint256",
            },
        ],
        name: "DepositMade",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "depositType",
                type: "uint256",
            },
        ],
        name: "DepositType",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "DepositedAmountToYearnVault",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "PermittedForTransfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "rewardee",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "RewardIssued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "SwappedBUSDCToBUMP",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TransferUsdc",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSwapRateParameter1",
                type: "uint256",
            },
        ],
        name: "UpdateSwapRateParameter1",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSwapRateParameter2",
                type: "uint256",
            },
        ],
        name: "UpdateSwapRateParameter2",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newTotalDeposits",
                type: "uint256",
            },
        ],
        name: "UpdateTotalDeposits",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBumpPurchaseAllocation",
                type: "uint256",
            },
        ],
        name: "UpdatedBumpPurchaseAllocation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBumpRewardAllocation",
                type: "uint256",
            },
        ],
        name: "UpdatedBumpRewardAllocation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newFee",
                type: "uint256",
            },
        ],
        name: "UpdatedFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newLevy",
                type: "uint256",
            },
        ],
        name: "UpdatedLevy",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMaxBumpPercent",
                type: "uint256",
            },
        ],
        name: "UpdatedMaxBumpPercent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "start",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "end",
                type: "uint256",
            },
        ],
        name: "UpdatedSwapAllowedPeriod",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokensBurnt",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "usdcWithdrawn",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "WithdrawUsdc",
        type: "event",
    },
    {
        inputs: [],
        name: "BUMP_INITAL_PRICE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BUMP_REWARDS_BONUS_DRAG",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BUMP_REWARDS_BONUS_DRAG_DIVIDER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BUMP_REWARDS_FORMULA_CONSTANT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SWAP_RATE_CONSTANT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "addAddressToWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "approveUSDCToYearnVault",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "bumpPurchaseAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bumpRewardAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bumpTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "busdcTokenAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTVL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountForBumpPurchase",
                type: "uint256",
            },
            {
                internalType: "enum BumpMarketV2.StableCoins",
                name: "_coin",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_depositType",
                type: "uint256",
            },
        ],
        name: "depositAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountForBumpPurchase",
                type: "uint256",
            },
            {
                internalType: "enum BumpMarketV2.StableCoins",
                name: "_coin",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_depositType",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "depositAmountWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "depositDetails",
        outputs: [
            {
                internalType: "uint256",
                name: "interest",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "depositUSDCInYearnVault",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalDeposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amountForPurchase",
                type: "uint256",
            },
        ],
        name: "estimateBumpRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_deposit",
                type: "uint256",
            },
        ],
        name: "estimateSwapRateBumpUsdc",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum BumpMarketV2.StableCoins",
                name: "_coin",
                type: "uint8",
            },
        ],
        name: "getCurrentPrice",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSwapRateBumpUsdc",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getyUSDCIssuedToReserve",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "levy",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxBumpPercent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseProtocol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "removeAddressFromWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "swap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "swapAllowedPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "start",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "end",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "swapRateParameter1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "swapRateParameter2",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalDeposits",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalDepositsInit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpauseProtocol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bumpPurchaseAllocation",
                type: "uint256",
            },
        ],
        name: "updateBumpPurchaseAllocation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_bumpRewardAllocation",
                type: "uint256",
            },
        ],
        name: "updateBumpRewardAllocation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_fee",
                type: "uint256",
            },
        ],
        name: "updateFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_levy",
                type: "uint256",
            },
        ],
        name: "updateLevy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxBumpPercent",
                type: "uint256",
            },
        ],
        name: "updateMaxBumpPercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_start",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_end",
                type: "uint256",
            },
        ],
        name: "updateSwapAllowedPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_swapRateParameter1",
                type: "uint256",
            },
        ],
        name: "updateSwapRateParameter1",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_swapRateParameter2",
                type: "uint256",
            },
        ],
        name: "updateSwapRateParameter2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "usdcForBumpPurchase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "usdcVault",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawLiquidity",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawLiquidity",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdrawUSDCFromYearnVault",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdrawUSDCFromYearnVaultToAddress",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode$9 = "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";
var isSuperArgs$9 = function (xs) { return xs.length > 1; };
var BumpMarketV2__factory = /** @class */ (function (_super) {
    __extends(BumpMarketV2__factory, _super);
    function BumpMarketV2__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$9(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$e, _bytecode$9, args[0]) || this;
        }
        return _this;
    }
    BumpMarketV2__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BumpMarketV2__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BumpMarketV2__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BumpMarketV2__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BumpMarketV2__factory.createInterface = function () {
        return new utils.Interface(_abi$e);
    };
    BumpMarketV2__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$e, signerOrProvider);
    };
    BumpMarketV2__factory.bytecode = _bytecode$9;
    BumpMarketV2__factory.abi = _abi$e;
    return BumpMarketV2__factory;
}(ContractFactory));

var _abi$d = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "addAddressInWhiteList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "c__0x00e084d0",
                type: "bytes32",
            },
        ],
        name: "c_0x00e084d0",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "c__0x275f831b",
                type: "bytes32",
            },
        ],
        name: "c_0x275f831b",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "c__0x3cd00ab0",
                type: "bytes32",
            },
        ],
        name: "c_0x3cd00ab0",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "distributeToAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "_lockTimeStamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bumpSupply",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_whiteListAddresses",
                type: "address[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_increaseInSupply",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "removeAddressFromWhiteList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unlockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_unlockTimestamp",
                type: "uint256",
            },
        ],
        name: "updateUnlockTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode$8 = "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";
var isSuperArgs$8 = function (xs) { return xs.length > 1; };
var BumpToken__factory = /** @class */ (function (_super) {
    __extends(BumpToken__factory, _super);
    function BumpToken__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$8(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$d, _bytecode$8, args[0]) || this;
        }
        return _this;
    }
    BumpToken__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BumpToken__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BumpToken__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BumpToken__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BumpToken__factory.createInterface = function () {
        return new utils.Interface(_abi$d);
    };
    BumpToken__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$d, signerOrProvider);
    };
    BumpToken__factory.bytecode = _bytecode$8;
    BumpToken__factory.abi = _abi$d;
    return BumpToken__factory;
}(ContractFactory));

var _abi$c = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_gac",
                type: "address",
            },
            {
                internalType: "address",
                name: "_market",
                type: "address",
            },
            {
                internalType: "address",
                name: "_feed",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_DIVIDER_ASSET",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_DIVIDER_STABLE",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "ADAPTER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "AP",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "AR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "B",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CP",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CR",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "D",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ASSET",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ORACLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ORACLE_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_STABLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "E",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "GLOBAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "L",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LOCAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "RWA",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "RWCn",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "RWCp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "RWL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UDIVIDER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calc",
        outputs: [
            {
                internalType: "contract IRiskCalculation",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calcCI",
        outputs: [
            {
                internalType: "uint256",
                name: "cia",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cis",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ciMaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ciTakerAsset",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ciTakerStable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "floor",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        name: "claimTakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "int256",
                name: "yield",
                type: "int256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        name: "closeMakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "floor",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        name: "closeTakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "feed",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gac",
        outputs: [
            {
                internalType: "contract IGlobalAccessControl",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getState",
        outputs: [
            {
                internalType: "uint256",
                name: "_AP",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_AR",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_CP",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_CR",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_B",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_L",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_D",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_E",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getStateAsStruct",
        outputs: [
            {
                components: [
                    {
                        internalType: "int256",
                        name: "AP",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "AR",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "CP",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "CR",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "B",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "L",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "D",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "E",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "RWA",
                        type: "int256",
                    },
                ],
                internalType: "struct MarketState",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "getTakerRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastPrice",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastRoundId",
        outputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastUsedPrice",
        outputs: [
            {
                internalType: "int256",
                name: "_price",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "_updatedAt",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "_roundId",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "market",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "newMakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "floor",
                type: "uint256",
            },
        ],
        name: "newTakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "price",
        outputs: [
            {
                internalType: "int256",
                name: "_price",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "_updatedAt",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "_roundId",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint80",
                name: "_roundId",
                type: "uint80",
            },
        ],
        name: "priceAt",
        outputs: [
            {
                internalType: "int256",
                name: "_price",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "_updatedAt",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "probabilityOfClaim",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rebalancer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rebalancer",
                type: "address",
            },
        ],
        name: "setRebalancer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_calc",
                type: "address",
            },
        ],
        name: "setRiskCalc",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "deltaAP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "deltaAR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "deltaCP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "deltaCR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "deltaE",
                type: "int256",
            },
        ],
        name: "update",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateStateToCurrentTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateStateToLastPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "userHasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode$7 = "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";
var isSuperArgs$7 = function (xs) { return xs.length > 1; };
var CIState__factory = /** @class */ (function (_super) {
    __extends(CIState__factory, _super);
    function CIState__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$7(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$c, _bytecode$7, args[0]) || this;
        }
        return _this;
    }
    CIState__factory.prototype.deploy = function (_gac, _market, _feed, _DIVIDER_ASSET, _DIVIDER_STABLE, overrides) {
        return _super.prototype.deploy.call(this, _gac, _market, _feed, _DIVIDER_ASSET, _DIVIDER_STABLE, overrides || {});
    };
    CIState__factory.prototype.getDeployTransaction = function (_gac, _market, _feed, _DIVIDER_ASSET, _DIVIDER_STABLE, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _gac, _market, _feed, _DIVIDER_ASSET, _DIVIDER_STABLE, overrides || {});
    };
    CIState__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CIState__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CIState__factory.createInterface = function () {
        return new utils.Interface(_abi$c);
    };
    CIState__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$c, signerOrProvider);
    };
    CIState__factory.bytecode = _bytecode$7;
    CIState__factory.abi = _abi$c;
    return CIState__factory;
}(ContractFactory));

/* Autogenerated file. Do not edit manually. */
var _abi$b = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_config",
                type: "address",
            },
            {
                internalType: "address",
                name: "_state",
                type: "address",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_DIVIDER_ASSET",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_DIVIDER_STABLE",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "betta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "B",
                type: "int256",
            },
        ],
        name: "AL",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "betta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "D",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "L",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "E",
                type: "int256",
            },
        ],
        name: "CL",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_L1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_L11",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_L12",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_L2",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_U1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_U11",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_U12",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DB_U2",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ASSET",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ORACLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ORACLE_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_STABLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "B",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "L",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "D",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "E",
                type: "int256",
            },
        ],
        name: "LRF",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
        ],
        name: "LRR1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
        ],
        name: "LRR11",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
        ],
        name: "LRR12",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
        ],
        name: "LRR2",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_01_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_01_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_02_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_02_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_03_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_03_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_04_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_04_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_05_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_120_05_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_01_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_01_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_02_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_02_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_03_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_03_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_04_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_04_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_05_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_150_05_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_01_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_01_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_02_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_02_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_03_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_03_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_04_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_04_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_05_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_30_05_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_01_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_01_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_02_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_02_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_03_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_03_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_04_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_04_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_05_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_60_05_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_01_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_01_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_02_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_02_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_03_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_03_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_04_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_04_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_05_NEGATIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "M_90_05_POSITIVE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_L1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_L11",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_L12",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_L2",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_U1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_U11",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_U12",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PB_U2",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "_u1",
                type: "int256",
            },
        ],
        name: "PRF",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_120_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_150_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_30_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_60_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_70",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_80",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_85",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_90",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "T_90_95",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "currentPrice",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "previousPrice",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "previousTime",
                type: "uint256",
            },
        ],
        name: "U1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "UDIVIDER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "price",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "B",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "L",
                type: "int256",
            },
        ],
        name: "VRF",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "B",
                type: "int256",
            },
        ],
        name: "W1",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "L",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "D",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "E",
                type: "int256",
            },
        ],
        name: "W11",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "CR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "L",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "D",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "E",
                type: "int256",
            },
        ],
        name: "W12",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "beta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AP",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "AR",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "B",
                type: "int256",
            },
        ],
        name: "W2",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "YIELD_EPSILON",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "boostParameters",
        outputs: [
            {
                components: [
                    {
                        internalType: "int256",
                        name: "w1max",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "w11max",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "w1",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "lrr1",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "w11",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "lrr11",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "pbl1",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "pbl11",
                        type: "int256",
                    },
                ],
                internalType: "struct BoostingParameters",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "start",
                type: "uint32",
            },
        ],
        name: "calcMakerPositionFee",
        outputs: [
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "toCurrentTime",
                type: "bool",
            },
        ],
        name: "calcNewPaps",
        outputs: [
            {
                internalType: "uint256",
                name: "papsInAsset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "papsInStable",
                type: "uint256",
            },
            {
                internalType: "int256",
                name: "_lastPrice",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "_lastTimestamp",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "_lastRoundId",
                type: "uint80",
            },
            {
                internalType: "uint256",
                name: "_probabilityOfClaim",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "start",
                type: "uint32",
            },
        ],
        name: "calcTakerPositionFee",
        outputs: [
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "ci",
                type: "uint256",
            },
        ],
        name: "commonPremium",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "ci",
                type: "uint256",
            },
        ],
        name: "commonYield",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "config",
        outputs: [
            {
                internalType: "contract IProtocolConfig",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "getMakerRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "getTakerRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "market",
        outputs: [
            {
                internalType: "contract IMarket",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "price",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "B",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "L",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "_PRF",
                type: "int256",
            },
        ],
        name: "pClaim",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "premiumOnCancel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "premiumOnClaim",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "premiumOnClose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rebalanceAmount",
        outputs: [
            {
                components: [
                    {
                        internalType: "int256",
                        name: "deltaAP",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "deltaAR",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "deltaCP",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "deltaCR",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "deltaL",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "deltaB",
                        type: "int256",
                    },
                    {
                        internalType: "int256",
                        name: "deltaE",
                        type: "int256",
                    },
                    {
                        internalType: "uint256",
                        name: "sellToken",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "sellStable",
                        type: "uint256",
                    },
                ],
                internalType: "struct RebalanceAmount",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stable",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state",
        outputs: [
            {
                internalType: "contract IState",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "validateMakerPos",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "validateTakerPos",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "yieldOnAbandon",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "yieldOnWithdraw",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var Calculation__factory = /** @class */ (function () {
    function Calculation__factory() {
    }
    Calculation__factory.createInterface = function () {
        return new utils.Interface(_abi$b);
    };
    Calculation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$b, signerOrProvider);
    };
    Calculation__factory.abi = _abi$b;
    return Calculation__factory;
}());

/* Autogenerated file. Do not edit manually. */
var _abi$a = [
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "description",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint80",
                name: "_roundId",
                type: "uint80",
            },
        ],
        name: "getRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "roundId",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "answer",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "startedAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "answeredInRound",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "roundId",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "answer",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "startedAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "answeredInRound",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var ChainLinkAgregatorABI__factory = /** @class */ (function () {
    function ChainLinkAgregatorABI__factory() {
    }
    ChainLinkAgregatorABI__factory.createInterface = function () {
        return new utils.Interface(_abi$a);
    };
    ChainLinkAgregatorABI__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$a, signerOrProvider);
    };
    ChainLinkAgregatorABI__factory.abi = _abi$a;
    return ChainLinkAgregatorABI__factory;
}());

var _abi$9 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_config",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stable",
                type: "address",
            },
            {
                internalType: "address",
                name: "_market",
                type: "address",
            },
            {
                internalType: "address",
                name: "_bst",
                type: "address",
            },
            {
                internalType: "address",
                name: "_bond",
                type: "address",
            },
            {
                internalType: "address",
                name: "_incentives",
                type: "address",
            },
            {
                internalType: "address",
                name: "_bump",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "reward",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
        ],
        name: "Abandon",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "permitted",
                type: "bool",
            },
        ],
        name: "AbandonmentPermit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
        ],
        name: "Cancel",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "permitted",
                type: "bool",
            },
        ],
        name: "CancellationPermit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "floor",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
        ],
        name: "Claim",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
        ],
        name: "Close",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "boost",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "incentives",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "floor",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "boost",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "incentives",
                type: "uint256",
            },
        ],
        name: "Protect",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "reward",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assetAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "stableAmount",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "ASSET_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_STABLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "GLOBAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LOCAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "STABLE_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "abandon",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "abandonmentPermitted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bond",
        outputs: [
            {
                internalType: "contract IBond",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bst",
        outputs: [
            {
                internalType: "contract IBST",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bump",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "canEject",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "unwrap",
                type: "bool",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancellationPermitted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "withdrawBond",
                type: "bool",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "unwrap",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "withdrawBond",
                type: "bool",
            },
        ],
        name: "close",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "config",
        outputs: [
            {
                internalType: "contract IProtocolConfig",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
        ],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "depositWithAutoBondingPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "depositWithPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "permitStable",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "permitBump",
                type: "bytes",
            },
        ],
        name: "depositWithPermitWithAutoBondingPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ejectR",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "gac",
        outputs: [
            {
                internalType: "contract IGlobalAccessControl",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getMakerPosition",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "tier",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct MakerPosition",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getTakerPosition",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "floor",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "risk",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct TakerPosition",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "govWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "incentives",
        outputs: [
            {
                internalType: "contract IIncentives",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "market",
        outputs: [
            {
                internalType: "contract IMarket",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minMakerPositionSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minTakerPositionSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
        ],
        name: "protect",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
        ],
        name: "protectNative",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "protectWithAutoBondingPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "protectWithPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "permitAsset",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "permitBump",
                type: "bytes",
            },
        ],
        name: "protectWithPermitWithAutoBondingPermit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "minMaker",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minTaker",
                type: "uint256",
            },
        ],
        name: "setMinPositionSize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stable",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleAbandonment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleCancellation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "toggleMakerAutorenew",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "toggleTakerAutorenew",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "userHasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "withdrawBond",
                type: "bool",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wrappedNativeMarket",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode$6 = "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";
var isSuperArgs$6 = function (xs) { return xs.length > 1; };
var ClientMarketAdapter__factory = /** @class */ (function (_super) {
    __extends(ClientMarketAdapter__factory, _super);
    function ClientMarketAdapter__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$6(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$9, _bytecode$6, args[0]) || this;
        }
        return _this;
    }
    ClientMarketAdapter__factory.prototype.deploy = function (_config, _stable, _market, _bst, _bond, _incentives, _bump, overrides) {
        return _super.prototype.deploy.call(this, _config, _stable, _market, _bst, _bond, _incentives, _bump, overrides || {});
    };
    ClientMarketAdapter__factory.prototype.getDeployTransaction = function (_config, _stable, _market, _bst, _bond, _incentives, _bump, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _config, _stable, _market, _bst, _bond, _incentives, _bump, overrides || {});
    };
    ClientMarketAdapter__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ClientMarketAdapter__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ClientMarketAdapter__factory.createInterface = function () {
        return new utils.Interface(_abi$9);
    };
    ClientMarketAdapter__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$9, signerOrProvider);
    };
    ClientMarketAdapter__factory.bytecode = _bytecode$6;
    ClientMarketAdapter__factory.abi = _abi$9;
    return ClientMarketAdapter__factory;
}(ContractFactory));

/* Autogenerated file. Do not edit manually. */
var _abi$8 = [
    {
        inputs: [],
        name: "BOND_TOKEN_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "boostAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "incentivesAmount",
                type: "uint256",
            },
        ],
        name: "autoLockBondMakerPosition",
        outputs: [
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toTransfer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toReduce",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "boostAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "incentivesAmount",
                type: "uint256",
            },
        ],
        name: "autoLockBondTakerPosition",
        outputs: [
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toTransfer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toReduce",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "calcBondSizeForMakerPosition",
        outputs: [
            {
                internalType: "uint256",
                name: "toLock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toTransfer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toReduce",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "calcBondSizeForTakerPosition",
        outputs: [
            {
                internalType: "uint256",
                name: "toLock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toTransfer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toReduce",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "bumpPrice",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "assetPrice",
                type: "uint256",
            },
        ],
        name: "calcBonding",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "depositTo",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "depositTo",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "depositWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "liquidate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "lock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "lockedOf",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "makerBond",
        outputs: [
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
        ],
        name: "makerToSwap",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "thetaAsset1",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "thetaStable1",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "thetaAsset2",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "thetaStable2",
                type: "uint256",
            },
        ],
        name: "setBondTheta",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
        ],
        name: "takerBond",
        outputs: [
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
        ],
        name: "takerToSwap",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferLocked",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "bondAmount",
                type: "uint256",
            },
        ],
        name: "unlock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "withdrawOf",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var IBond__factory = /** @class */ (function () {
    function IBond__factory() {
    }
    IBond__factory.createInterface = function () {
        return new utils.Interface(_abi$8);
    };
    IBond__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$8, signerOrProvider);
    };
    IBond__factory.abi = _abi$8;
    return IBond__factory;
}());

/* Autogenerated file. Do not edit manually. */
var _abi$7 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var IERC20__factory = /** @class */ (function () {
    function IERC20__factory() {
    }
    IERC20__factory.createInterface = function () {
        return new utils.Interface(_abi$7);
    };
    IERC20__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$7, signerOrProvider);
    };
    IERC20__factory.abi = _abi$7;
    return IERC20__factory;
}());

var _abi$6 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "GLOBAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LOCAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gac",
        outputs: [
            {
                internalType: "contract IGlobalAccessControl",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAssets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "getBToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGAC",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "getMarket",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "getNFTMaker",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "getNFTTaker",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRebalancer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getStable",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getVersion",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getWrappedNativeMarket",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getWrappedNativeToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_gac",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "makerNFTPosition",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "removeMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_bToken",
                type: "address",
            },
        ],
        name: "setBToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_market",
                type: "address",
            },
        ],
        name: "setMarket",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "taker",
                type: "address",
            },
            {
                internalType: "address",
                name: "maker",
                type: "address",
            },
        ],
        name: "setNFT",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stable",
                type: "address",
            },
        ],
        name: "setStable",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "_version",
                type: "uint16",
            },
        ],
        name: "setVersion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wnative",
                type: "address",
            },
        ],
        name: "setWrappedNativeToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "takerNFTPosition",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "userHasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode$5 = "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";
var isSuperArgs$5 = function (xs) { return xs.length > 1; };
var IProtocolConfig__factory = /** @class */ (function (_super) {
    __extends(IProtocolConfig__factory, _super);
    function IProtocolConfig__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$5(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$6, _bytecode$5, args[0]) || this;
        }
        return _this;
    }
    IProtocolConfig__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    IProtocolConfig__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    IProtocolConfig__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    IProtocolConfig__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    IProtocolConfig__factory.createInterface = function () {
        return new utils.Interface(_abi$6);
    };
    IProtocolConfig__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$6, signerOrProvider);
    };
    IProtocolConfig__factory.bytecode = _bytecode$5;
    IProtocolConfig__factory.abi = _abi$6;
    return IProtocolConfig__factory;
}(ContractFactory));

var _abi$5 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_gac",
                type: "address",
            },
            {
                internalType: "address",
                name: "_bst",
                type: "address",
            },
            {
                internalType: "address",
                name: "_config",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ORACLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "GLOBAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LOCAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "boostForMaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "boostForTaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "boostMax",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "calculateCoordination",
        outputs: [
            {
                internalType: "uint256",
                name: "incentive",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "coordinationForMaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "coordinationForTaker",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gac",
        outputs: [
            {
                internalType: "contract IGlobalAccessControl",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "_boostMax",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "_thetaBoost",
                type: "int256",
            },
        ],
        name: "setBoostConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_scale",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_inflection",
                type: "uint256",
            },
        ],
        name: "setIncentiveConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "thetaBoost",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "thetaInflection",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "thetaScale",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "updateBoosting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "userHasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode$4 = "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";
var isSuperArgs$4 = function (xs) { return xs.length > 1; };
var Incentives__factory = /** @class */ (function (_super) {
    __extends(Incentives__factory, _super);
    function Incentives__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$4(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$5, _bytecode$4, args[0]) || this;
        }
        return _this;
    }
    Incentives__factory.prototype.deploy = function (_gac, _bst, _config, overrides) {
        return _super.prototype.deploy.call(this, _gac, _bst, _config, overrides || {});
    };
    Incentives__factory.prototype.getDeployTransaction = function (_gac, _bst, _config, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _gac, _bst, _config, overrides || {});
    };
    Incentives__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Incentives__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Incentives__factory.createInterface = function () {
        return new utils.Interface(_abi$5);
    };
    Incentives__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$5, signerOrProvider);
    };
    Incentives__factory.bytecode = _bytecode$4;
    Incentives__factory.abi = _abi$5;
    return Incentives__factory;
}(ContractFactory));

/* Autogenerated file. Do not edit manually. */
var _abi$4 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "ADAPTER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ASSET",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "ASSET_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "BOND_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_ASSET",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "DIVIDER_STABLE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "GLOBAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LOCAL_GOVERNANCE_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "STABLE",
        outputs: [
            {
                internalType: "contract IERC20Upgradeable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "STABLE_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "stable",
                type: "address",
            },
        ],
        name: "abandon",
        outputs: [
            {
                internalType: "int256",
                name: "yield",
                type: "int256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "unwrap",
                type: "bool",
            },
            {
                internalType: "address",
                name: "stable",
                type: "address",
            },
        ],
        name: "cancel",
        outputs: [
            {
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "stable",
                type: "address",
            },
        ],
        name: "claim",
        outputs: [
            {
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "unwrap",
                type: "bool",
            },
            {
                internalType: "address",
                name: "stable",
                type: "address",
            },
        ],
        name: "close",
        outputs: [
            {
                internalType: "uint256",
                name: "premium",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toTreasury",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "tier",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
        ],
        name: "deposit",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "existsMakerPosition",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "existsTakerPosition",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gac",
        outputs: [
            {
                internalType: "contract IGlobalAccessControl",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getMakerPosition",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "tier",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct MakerPosition",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getMakerPositionBond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "getMakerPositions",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRiskCalc",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getState",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getTakerPosition",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "floor",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "risk",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct TakerPosition",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "getTakerPositionBond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "getTakerPositions",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getUserProfile",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "govWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "makerPositionCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "makerPositionOptions",
        outputs: [
            {
                internalType: "uint32",
                name: "start",
                type: "uint32",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "makerPositionOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "tier",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct MakerPosition",
                name: "pos",
                type: "tuple",
            },
        ],
        name: "newMakerPositon",
        outputs: [
            {
                internalType: "uint256",
                name: "newId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "floor",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "risk",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct TakerPosition",
                name: "pos",
                type: "tuple",
            },
        ],
        name: "newTakerPositon",
        outputs: [
            {
                internalType: "uint256",
                name: "newId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "premiumOnCancel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "premiumOnClaim",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "premiumOnClose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "toTreasury",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "bumpAmount",
                type: "uint256",
            },
            {
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
        ],
        name: "protect",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "floor",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "resetReserves",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "safeTransferMakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "safeTransferTakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_adapter",
                type: "address",
            },
        ],
        name: "setAdapterAllowance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_bond",
                type: "address",
            },
        ],
        name: "setBond",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
        ],
        name: "setMakerPositionFlags",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rebalancer",
                type: "address",
            },
        ],
        name: "setRebalancer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_calc",
                type: "address",
            },
        ],
        name: "setRiskCalc",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_state",
                type: "address",
            },
        ],
        name: "setState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
        ],
        name: "setTakerPositionFlags",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "profile",
                type: "uint256",
            },
        ],
        name: "setUserProfile",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "takerPositionCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "takerPositionOptions",
        outputs: [
            {
                internalType: "uint32",
                name: "start",
                type: "uint32",
            },
            {
                internalType: "uint16",
                name: "risk",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "term",
                type: "uint16",
            },
            {
                internalType: "uint192",
                name: "flags",
                type: "uint192",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "takerPositionOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tcr",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "tier",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct MakerPosition",
                name: "pos",
                type: "tuple",
            },
        ],
        name: "updateMakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "floor",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "bumpAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "ci",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "start",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "risk",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "term",
                        type: "uint16",
                    },
                    {
                        internalType: "uint192",
                        name: "flags",
                        type: "uint192",
                    },
                ],
                internalType: "struct TakerPosition",
                name: "pos",
                type: "tuple",
            },
        ],
        name: "updateTakerPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "userHasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "stable",
                type: "address",
            },
        ],
        name: "withdraw",
        outputs: [
            {
                internalType: "int256",
                name: "yield",
                type: "int256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "assetAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "stableAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct Payout",
                name: "payout",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "yieldOnAbandon",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "yieldOnWithdraw",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
var Market__factory = /** @class */ (function () {
    function Market__factory() {
    }
    Market__factory.createInterface = function () {
        return new utils.Interface(_abi$4);
    };
    Market__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$4, signerOrProvider);
    };
    Market__factory.abi = _abi$4;
    return Market__factory;
}());

var _abi$3 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
            {
                internalType: "address",
                name: "_WETH9",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "WETH9",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "path",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
        ],
        name: "quoteExactInput",
        outputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenOut",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "uint160",
                name: "sqrtPriceLimitX96",
                type: "uint160",
            },
        ],
        name: "quoteExactInputSingle",
        outputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "path",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
        ],
        name: "quoteExactOutput",
        outputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenIn",
                type: "address",
            },
            {
                internalType: "address",
                name: "tokenOut",
                type: "address",
            },
            {
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "uint160",
                name: "sqrtPriceLimitX96",
                type: "uint160",
            },
        ],
        name: "quoteExactOutputSingle",
        outputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "amount0Delta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "amount1Delta",
                type: "int256",
            },
            {
                internalType: "bytes",
                name: "path",
                type: "bytes",
            },
        ],
        name: "uniswapV3SwapCallback",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode$3 = "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";
var isSuperArgs$3 = function (xs) { return xs.length > 1; };
var Quoter__factory = /** @class */ (function (_super) {
    __extends(Quoter__factory, _super);
    function Quoter__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$3(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$3, _bytecode$3, args[0]) || this;
        }
        return _this;
    }
    Quoter__factory.prototype.deploy = function (_factory, _WETH9, overrides) {
        return _super.prototype.deploy.call(this, _factory, _WETH9, overrides || {});
    };
    Quoter__factory.prototype.getDeployTransaction = function (_factory, _WETH9, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _factory, _WETH9, overrides || {});
    };
    Quoter__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Quoter__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Quoter__factory.createInterface = function () {
        return new utils.Interface(_abi$3);
    };
    Quoter__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$3, signerOrProvider);
    };
    Quoter__factory.bytecode = _bytecode$3;
    Quoter__factory.abi = _abi$3;
    return Quoter__factory;
}(ContractFactory));

var _abi$2 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressAddedToWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "removedWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressRemovedFromWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldEmission",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newEmission",
                type: "uint256",
            },
        ],
        name: "ChangeEmission",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "period",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
        ],
        name: "WithdrawRequested",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewards",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
        ],
        name: "Withdrawn",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "addAddressToWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lastCI",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "start",
                        type: "uint64",
                    },
                    {
                        internalType: "uint16",
                        name: "option",
                        type: "uint16",
                    },
                    {
                        internalType: "bool",
                        name: "autorenew",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "end",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "requestedAt",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "claimed",
                        type: "uint256",
                    },
                ],
                internalType: "struct StakeInfo",
                name: "s",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "total",
                        type: "uint256",
                    },
                    {
                        internalType: "uint128",
                        name: "emission",
                        type: "uint128",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                ],
                internalType: "struct StakeOption",
                name: "opt",
                type: "tuple",
            },
        ],
        name: "calcRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "rewards",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "claimable",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "withdrawable",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "endOfLastPeriod",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "stakeIndex",
                type: "uint16",
            },
        ],
        name: "calcRewardsByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "rewards",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "claimable",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "withdrawable",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "endOfLastPeriod",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
        ],
        name: "calculateCumulativeIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "stakeIndex",
                type: "uint16",
            },
        ],
        name: "claimRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cooldownPeriod",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "freeAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getStakeOptions",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "total",
                        type: "uint256",
                    },
                    {
                        internalType: "uint128",
                        name: "emission",
                        type: "uint128",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                ],
                internalType: "struct StakeOption[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "getUserStakes",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lastCI",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "start",
                        type: "uint64",
                    },
                    {
                        internalType: "uint16",
                        name: "option",
                        type: "uint16",
                    },
                    {
                        internalType: "bool",
                        name: "autorenew",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "end",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "requestedAt",
                        type: "uint64",
                    },
                    {
                        internalType: "uint256",
                        name: "claimed",
                        type: "uint256",
                    },
                ],
                internalType: "struct StakeInfo[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_whitelistAddresses",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "_stakeToken",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "_unlockTimestamp",
                type: "uint64",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lastIndexTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multipliers",
        outputs: [
            {
                internalType: "uint16[4]",
                name: "",
                type: "uint16[4]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "periods",
        outputs: [
            {
                internalType: "uint32[4]",
                name: "",
                type: "uint32[4]",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "removeAddressFromWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "stakeIndex",
                type: "uint16",
            },
        ],
        name: "requestWithdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "stakeIndex",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "withRewards",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
        ],
        name: "restake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newEmissionPerSecond",
                type: "uint256",
            },
        ],
        name: "setEmissionPerSecond",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
        ],
        name: "stakeFor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "stakeOptions",
        outputs: [
            {
                internalType: "uint256",
                name: "total",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "emission",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakeToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "stakeWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "stakeIndex",
                type: "uint16",
            },
        ],
        name: "switchAutorenew",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "weithedAmountSum",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalEmissionPerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalWeigthedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "weithedAmountSum",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unlockTimestamp",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "_timestamp",
                type: "uint64",
            },
        ],
        name: "updateUnlockTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "usersStake",
        outputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastCI",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "start",
                type: "uint64",
            },
            {
                internalType: "uint16",
                name: "option",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint64",
                name: "end",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "requestedAt",
                type: "uint64",
            },
            {
                internalType: "uint256",
                name: "claimed",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "stakeIndex",
                type: "uint16",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawExtraTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawWindow",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode$2 = "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";
var isSuperArgs$2 = function (xs) { return xs.length > 1; };
var StakeRewards__factory = /** @class */ (function (_super) {
    __extends(StakeRewards__factory, _super);
    function StakeRewards__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$2(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$2, _bytecode$2, args[0]) || this;
        }
        return _this;
    }
    StakeRewards__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    StakeRewards__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    StakeRewards__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    StakeRewards__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    StakeRewards__factory.createInterface = function () {
        return new utils.Interface(_abi$2);
    };
    StakeRewards__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$2, signerOrProvider);
    };
    StakeRewards__factory.bytecode = _bytecode$2;
    StakeRewards__factory.abi = _abi$2;
    return StakeRewards__factory;
}(ContractFactory));

var _abi$1 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_factory",
                type: "address",
            },
            {
                internalType: "address",
                name: "_WETH9",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "WETH9",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "path",
                        type: "bytes",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "deadline",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountOutMinimum",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISwapRouter.ExactInputParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "exactInput",
        outputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tokenIn",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenOut",
                        type: "address",
                    },
                    {
                        internalType: "uint24",
                        name: "fee",
                        type: "uint24",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "deadline",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountIn",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountOutMinimum",
                        type: "uint256",
                    },
                    {
                        internalType: "uint160",
                        name: "sqrtPriceLimitX96",
                        type: "uint160",
                    },
                ],
                internalType: "struct ISwapRouter.ExactInputSingleParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "exactInputSingle",
        outputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "path",
                        type: "bytes",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "deadline",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountOut",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountInMaximum",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISwapRouter.ExactOutputParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "exactOutput",
        outputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "tokenIn",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenOut",
                        type: "address",
                    },
                    {
                        internalType: "uint24",
                        name: "fee",
                        type: "uint24",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "deadline",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountOut",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amountInMaximum",
                        type: "uint256",
                    },
                    {
                        internalType: "uint160",
                        name: "sqrtPriceLimitX96",
                        type: "uint160",
                    },
                ],
                internalType: "struct ISwapRouter.ExactOutputSingleParams",
                name: "params",
                type: "tuple",
            },
        ],
        name: "exactOutputSingle",
        outputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "refundETH",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "selfPermit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "selfPermitAllowed",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "selfPermitAllowedIfNecessary",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "selfPermitIfNecessary",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amountMinimum",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "sweepToken",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amountMinimum",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "feeBips",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "feeRecipient",
                type: "address",
            },
        ],
        name: "sweepTokenWithFee",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "amount0Delta",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "amount1Delta",
                type: "int256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "uniswapV3SwapCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountMinimum",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "unwrapWETH9",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountMinimum",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "feeBips",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "feeRecipient",
                type: "address",
            },
        ],
        name: "unwrapWETH9WithFee",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
var _bytecode$1 = "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";
var isSuperArgs$1 = function (xs) { return xs.length > 1; };
var SwapRouter__factory = /** @class */ (function (_super) {
    __extends(SwapRouter__factory, _super);
    function SwapRouter__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs$1(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi$1, _bytecode$1, args[0]) || this;
        }
        return _this;
    }
    SwapRouter__factory.prototype.deploy = function (_factory, _WETH9, overrides) {
        return _super.prototype.deploy.call(this, _factory, _WETH9, overrides || {});
    };
    SwapRouter__factory.prototype.getDeployTransaction = function (_factory, _WETH9, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _factory, _WETH9, overrides || {});
    };
    SwapRouter__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SwapRouter__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SwapRouter__factory.createInterface = function () {
        return new utils.Interface(_abi$1);
    };
    SwapRouter__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi$1, signerOrProvider);
    };
    SwapRouter__factory.bytecode = _bytecode$1;
    SwapRouter__factory.abi = _abi$1;
    return SwapRouter__factory;
}(ContractFactory));

var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressAddedToWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "removedWhitelistAddress",
                type: "address",
            },
        ],
        name: "AddressRemovedFromWhitelist",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "Claimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "addAddressToWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "start",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "end",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cliff",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "vestingPerSec",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "onStartAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "previousAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "claimedV1",
                        type: "uint256",
                    },
                ],
                internalType: "struct Vesting.VestingInfo",
                name: "vestingInfo",
                type: "tuple",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "start",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "end",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cliff",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "vestingPerSec",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "onStartAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "previousAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "claimedV1",
                        type: "uint256",
                    },
                ],
                internalType: "struct Vesting.VestingInfo",
                name: "vestingInfo",
                type: "tuple",
            },
        ],
        name: "getClaimableAmountFor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "_merkleRoot",
                type: "bytes32",
            },
            {
                internalType: "address[]",
                name: "_whitelistAddresses",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "_staking",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "merkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "recipientClaimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
        ],
        name: "removeAddressFromWhitelist",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32",
            },
        ],
        name: "setMerkleRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_staking",
                type: "address",
            },
        ],
        name: "setStakingContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "start",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "end",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cliff",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "vestingPerSec",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "onStartAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "previousAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "claimedV1",
                        type: "uint256",
                    },
                ],
                internalType: "struct Vesting.VestingInfo",
                name: "vestingInfo",
                type: "tuple",
            },
            {
                internalType: "uint16",
                name: "stakingOption",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "ownAmount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "stakeOwnAndVestedTokensWithApprove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "start",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "end",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cliff",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "vestingPerSec",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "onStartAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "previousAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "claimedV1",
                        type: "uint256",
                    },
                ],
                internalType: "struct Vesting.VestingInfo",
                name: "vestingInfo",
                type: "tuple",
            },
            {
                internalType: "uint16",
                name: "stakingOption",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "ownAmount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "stakeOwnAndVestedTokensWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "start",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "end",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cliff",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "vestingPerSec",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "onStartAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "previousAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "claimedV1",
                        type: "uint256",
                    },
                ],
                internalType: "struct Vesting.VestingInfo",
                name: "vestingInfo",
                type: "tuple",
            },
            {
                internalType: "uint16",
                name: "stakingOption",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "autorenew",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "claimAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "stakingAmount",
                type: "uint256",
            },
            {
                internalType: "bytes32[]",
                name: "merkleProof",
                type: "bytes32[]",
            },
        ],
        name: "stakeVestedTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "staking",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenBUMP",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "start",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "end",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cliff",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "vestingPerSec",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "onStartAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "previousAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "claimedV1",
                        type: "uint256",
                    },
                ],
                internalType: "struct Vesting.VestingInfo",
                name: "vestingInfo",
                type: "tuple",
            },
        ],
        name: "totalLockedOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var Vesting__factory = /** @class */ (function (_super) {
    __extends(Vesting__factory, _super);
    function Vesting__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    Vesting__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    Vesting__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    Vesting__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Vesting__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Vesting__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    Vesting__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    Vesting__factory.bytecode = _bytecode;
    Vesting__factory.abi = _abi;
    return Vesting__factory;
}(ContractFactory));

/* Autogenerated file. Do not edit manually. */

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Airdrop__factory: Airdrop__factory,
    BUSDC__factory: BUSDC__factory,
    BumpMarket__factory: BumpMarket__factory,
    BumpMarketV2__factory: BumpMarketV2__factory,
    BumpToken__factory: BumpToken__factory,
    CIState__factory: CIState__factory,
    Calculation__factory: Calculation__factory,
    ChainLinkAgregatorABI__factory: ChainLinkAgregatorABI__factory,
    ClientMarketAdapter__factory: ClientMarketAdapter__factory,
    IBond__factory: IBond__factory,
    IERC20__factory: IERC20__factory,
    IProtocolConfig__factory: IProtocolConfig__factory,
    Incentives__factory: Incentives__factory,
    Market__factory: Market__factory,
    Quoter__factory: Quoter__factory,
    StakeRewards__factory: StakeRewards__factory,
    SwapRouter__factory: SwapRouter__factory,
    Vesting__factory: Vesting__factory
});

export { Airdrop__factory, BUSDC__factory, BumpMarketV2__factory, BumpMarket__factory, BumpToken__factory, CIState__factory, Calculation__factory, ChainLinkAgregatorABI__factory, ClientMarketAdapter__factory, IBond__factory, IERC20__factory, IProtocolConfig__factory, Incentives__factory, Market__factory, Quoter__factory, StakeRewards__factory, SwapRouter__factory, Vesting__factory, index as factories };
//# sourceMappingURL=index.js.map
